import { NavLink } from "react-router-dom";

export default function NavigationBar({ activeTabId = 1 }) {
  const tabs = [
    {
      id: 1,
      title: "Kanban",
      path: "/kanban",
    },
    {
      id: 2,
      title: "Calendar",
      path: "/calendar",
    },
    {
      id: 3,
      title: "List",
      path: "/kanban-list",
    },
  ];

  return (
    <div className="tabs-header d-flex align-content-center gap-5 bg-white py-2 px-4 rounded-2">
      {tabs.map((tab) => (
        <NavLink
          className={activeTabId === tab.id ? "tab-active tab-t" : "tab-t"}
          key={tab.path + tab.title}
          to={"/app" + tab.path}
        >
          <span className="inter inter-medium" style={{ fontSize: "1.4rem" }}>
            {tab.title}
          </span>
        </NavLink>
      ))}
    </div>
  );
}
